import { EMAIL_ENABLED } from "@/config/features";

/**
 * Which outreach channels a candidate can actually be reached on, derived
 * from the candidate record itself rather than recomputed inline per screen.
 * Communication Centre and the candidate-analysis email tab both gate Send
 * on this — see .claude/rules/registries.md on keeping one truth in one
 * place instead of two copies that drift.
 */
export const useChannelAvailability = (candidate) => {
  const canEmail = EMAIL_ENABLED && !!candidate?.email;
  const canWhatsapp = !!candidate?.phone;
  // Telegram only becomes sendable once the candidate has clicked the invite
  // link and messaged the bot (a bot can never message someone first) — that
  // handshake is what sets telegram_chat_id. Some responses carry only the
  // boolean `telegram_linked` instead of the id.
  const canTelegram = !!(candidate?.telegram_chat_id || candidate?.telegram_linked);

  return { canEmail, canWhatsapp, canTelegram };
};

export default useChannelAvailability;
